import Axios from "axios";

// const axios = Axios.create({
//   // baseURL: process.env.VITE_BACKEND_URL
//   baseURL: import.meta.env.VITE_BACKEND_URL,
//   headers: {
//     "X-Requested-With": "XMLHttpRequest",
//     "Cache-Control": "no-cache",
//     Pragma: "no-cache",
//     Expires: "0",
//   },
//   withCredentials: true,
//   withXSRFToken: true,
// });

const axios = (header_params) => {
  let headers = {
    "X-Requested-With": "XMLHttpRequest",
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
    Expires: "0",
  };
  if (header_params) {
    headers = {
      ...headers,
      ...header_params,
    };
  }
  return Axios.create({
    baseURL: import.meta.env.VITE_BACKEND_URL,
    headers: headers,
    withCredentials: true,
    withXSRFToken: true,
  });
};

export default axios;

export const CancelToken = Axios.CancelToken;
